module.exports = __webpack_public_path__ + "img/logo_dark_hedge.f208bede.png";